/* BlackHype (2026-10-08): seletor de patches da PDP.
   Abre e fecha a gaveta, marca os itens e, ao adicionar a camisa ao carrinho, coloca antes os patches
   marcados (1 por camisa), amarrados à camisa pela propriedade _patch_link. */
(function () {
  'use strict';
  function iniciar(raiz) {
    if (raiz.dataset.bhPtPronto === '1') return;
    raiz.dataset.bhPtPronto = '1';
    var gatilho = raiz.querySelector('[data-bh-patches-trigger]');
    var sub = raiz.querySelector('[data-bh-patches-sub]');
    var caixas = raiz.querySelectorAll('.md-patches__check');
    var variantes = (raiz.getAttribute('data-bh-patches-variantes') || '').split(',');
    var camisa = raiz.getAttribute('data-bh-patches-camisa') || '';

    gatilho.addEventListener('click', function () { var aberto = raiz.classList.toggle('is-open'); gatilho.setAttribute('aria-expanded', aberto ? 'true' : 'false'); });
    function marcados() { var l = []; for (var i = 0; i < caixas.length; i++) if (caixas[i].checked) l.push(caixas[i]); return l; }
    function pintar() {
      for (var i = 0; i < caixas.length; i++) caixas[i].closest('.md-patches__item').classList.toggle('md-patches__item--marcado', caixas[i].checked);
      var n = marcados().length;
      if (sub) sub.textContent = n ? n + (n === 1 ? ' patch selected' : ' patches selected') : sub.getAttribute('data-inicial');
    }
    for (var i = 0; i < caixas.length; i++) caixas[i].addEventListener('change', pintar);
    pintar();

    var original = window.fetch;
    window.fetch = function (url, opcoes) {
      var self = this, args = arguments;
      var endereco = typeof url === 'string' ? url : (url && url.url) || '';
      if (endereco.indexOf('/cart/add') === -1 || !opcoes || !(opcoes.body instanceof FormData)) return original.apply(self, args);
      var escolhidos = marcados();
      var fd = opcoes.body;
      var id = String(fd.get('id') || '');
      if (!escolhidos.length || variantes.indexOf(id) === -1) return original.apply(self, args);
      var qtd = parseInt(fd.get('quantity') || '1', 10) || 1;
      var elo = 'pl_' + Date.now() + '_' + Math.floor(Math.random() * 100000);
      var nomes = escolhidos.map(function (c) { return c.getAttribute('data-bh-patch-nome'); });
      fd.set('properties[_patch_link]', elo);
      fd.set('properties[Patches]', nomes.join(', '));
      var itens = escolhidos.map(function (c) { return { id: parseInt(c.getAttribute('data-bh-patch-id'), 10), quantity: qtd, properties: { 'For': camisa, '_jersey_key': id, '_patch_link': elo } }; });
      var raizLoja = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return original.call(self, raizLoja + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: itens }) })
        .catch(function () { return null; })
        .then(function () { return original.apply(self, args); });
    };
  }
  function todos() { var l = document.querySelectorAll('[data-bh-patches]'); for (var i = 0; i < l.length; i++) iniciar(l[i]); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todos); else todos();
})();
